// Local storage keys
export const LANG_KEY = "language";

export const MENTIONS_ALL_ID = "mention-all";

// URL's
export const TERMS_OF_USE_URL = "https://jugl.com/terms-of-service";
export const PRIVACY_POLICY_URL = "https://jugl.com/privacy-policy";
